// Material Dashboard 2 React - v2.2.0

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Swal from "sweetalert2";

// Layout & Component Imports
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import MyModal from "components/Modal"; // Pastikan path sesuai
import { CloudUpload } from "@mui/icons-material";
import { Autocomplete, TextField, Typography } from "@mui/material";
// Data
import produkTableData from "layouts/Produk/data/produkTableData";
import BASE_URL from "config/Base_URL";
import imageCompression from "browser-image-compression";
import Placeholder from "../../../src/assets/images/placeholder.svg";
// Library
import { useState, useRef, useEffect } from "react";
import axios from "axios";

function Produk() {
  const token = sessionStorage.getItem("token");

  const [searchText, setSearchText] = useState("");

  const { columns, rows, modalEdit, modalDetail, modalDelete, listProduk } =
    produkTableData(searchText);
  const [modalShow, setModalShow] = useState(false);

  const [picture, setPicture] = useState(null);
  const [updatePicture, setUpdatePicture] = useState(null);
  const [name, setName] = useState("");
  const [unit, setUnit] = useState("");
  const [price, setPrice] = useState("");
  const [description, setDescription] = useState("");

  const formRef = useRef();
  const [formSubmittedProduct, setFormSubmittedProduct] = useState(false);

  const resetForm = () => {
    setPicture(null);
    setName("");
    setUnit("");
    setPrice("");
    setDescription("");
  };

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!allowedTypes.includes(file.type)) {
      Swal.fire("Gagal", "Format gambar harus JPG atau PNG!", "error");
      return;
    }

    // Buat nama file dengan ekstensi lowercase
    const nameParts = file.name.split(".");
    const ext = nameParts.pop().toLowerCase(); // lowercase extension
    const baseName = nameParts.join(".");
    const newFileName = `${baseName}.${ext}`;

    const originalSizeMB = parseFloat((file.size / 1024 / 1024).toFixed(1));
    let finalFile = new File([file], newFileName, {
      type: file.type,
      lastModified: file.lastModified,
    });

    // Kompres jika lebih dari 2MB
    if (file.size >= 2 * 1024 * 1024) {
      try {
        const options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1080,
          useWebWorker: true,
        };

        const compressedBlob = await imageCompression(file, options);

        const compressedFile = new File([compressedBlob], newFileName, {
          type: compressedBlob.type,
          lastModified: Date.now(),
        });

        const compressedSizeMB = parseFloat((compressedFile.size / 1024 / 1024).toFixed(1));

        if (compressedFile.size >= 2 * 1024 * 1024) {
          Swal.fire("Gagal", "Ukuran gambar setelah dikompres masih di atas 2MB.", "error");
          return;
        }

        finalFile = compressedFile;

        console.log("Sebelum:", originalSizeMB, "MB");
        console.log("Sesudah:", compressedSizeMB, "MB");
        console.log("Nama file hasil kompres:", compressedFile.name);
      } catch (error) {
        console.error("Gagal mengompres gambar:", error);
        Swal.fire("Gagal", "Terjadi kesalahan saat kompresi gambar.", "error");
        return;
      }
    } else {
      console.log("Ukuran gambar:", originalSizeMB, "MB (tidak dikompres)");
      console.log("Nama file:", finalFile.name);
    }

    setPicture(finalFile);
    setUpdatePicture(finalFile);
  };

  const handleAddProduk = async () => {
    if (!name || !unit || !description) {
      Swal.fire("Gagal", "Semua field wajib diisi!", "error");
      return;
    }

    let finalPicture = updatePicture || picture;

    if (!finalPicture || !(finalPicture instanceof File)) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/images/placeholder.png`);
        const blob = await response.blob();
        finalPicture = new File([blob], "placeholder.png", { type: "image/png" });
      } catch (error) {
        console.error("Gagal ambil gambar placeholder:", error);
        Swal.fire("Gagal", "Tidak bisa memuat gambar default", "error");
        return;
      }
    }

    if (!(finalPicture instanceof File) || !allowedTypes.includes(finalPicture.type)) {
      Swal.fire("Gagal", "Tipe file gambar tidak didukung!", "error");
      return;
    }

    const formData = new FormData();
    formData.append("picture", finalPicture);
    formData.append("name", name.toUpperCase());
    formData.append("unit", unit.toUpperCase());
    formData.append("price", price || 0);
    formData.append("description", description.toUpperCase());

    // Debug isi formData (opsional)
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    // Kirim data ke backend
    try {
      const response = await axios.post(`${BASE_URL}/add/product`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Produk berhasil ditambahkan",
        confirmButtonText: "OK",
      });

      resetForm();
      setModalShow(false);
    } catch (error) {
      console.error("Respon error backend:", error.response.data);
      console.error("Gagal menambahkan produk:", error);
      setModalShow(false);
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: "Produk gagal ditambahkan",
        confirmButtonText: "OK",
      });
    }
  };

  const renderForm = (
    <MDBox
      component="form"
      role="form"
      ref={formRef}
      onSubmit={(e) => {
        e.preventDefault();
        setFormSubmittedProduct(true);
      }}
    >
      <MDBox mb={2}>
        <input
          type="file"
          name="picture"
          id="picture-upload"
          accept=".jpg,.jpeg,.png"
          style={{ display: "none" }}
          onChange={handleImageUpload}
        />

        <label htmlFor="picture-upload">
          <MDBox
            sx={{
              border: "2px dashed #ccc",
              borderRadius: "8px",
              padding: "20px",
              textAlign: "center",
              cursor: "pointer",
              transition: "all 0.3s",
              "&:hover": {
                borderColor: "primary.main",
                backgroundColor: "rgba(0,0,0,0.02)",
              },
            }}
          >
            {picture ? (
              <>
                <img
                  src={URL.createObjectURL(picture)}
                  alt="Preview"
                  style={{
                    maxWidth: "100%",
                    maxHeight: "200px",
                    borderRadius: "4px",
                    marginBottom: "10px",
                  }}
                />
                <MDTypography variant="button" color="primary" fontWeight="medium">
                  Ganti Gambar
                </MDTypography>
              </>
            ) : (
              <>
                <CloudUpload fontSize="large" color="primary" />
                <MDTypography variant="h6" fontWeight="medium" mt={1} mb={0.5}>
                  Unggah Gambar Produk
                </MDTypography>
                <MDTypography variant="caption" color="text">
                  Seret gambar kesini atau klik untuk memilih
                </MDTypography>
                <MDTypography variant="caption" display="block" color="text" mt={1}>
                  Format: JPG, PNG (Maks. 2MB)
                </MDTypography>
              </>
            )}
          </MDBox>
        </label>
      </MDBox>

      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Name"
          fullWidth
          value={name}
          required
          onChange={(e) => setName(e.target.value.toUpperCase())}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Unit"
          fullWidth
          required
          value={unit}
          onChange={(e) => setUnit(e.target.value.toUpperCase())}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          type="text"
          label="Price"
          fullWidth
          required
          value={formatRupiah(price)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/[^0-9]/g, "");
            setPrice(onlyNums);
          }}
        />
      </MDBox>
      <MDBox mb={2}>
        <MDInput
          fullWidth
          label="Deskripsi Produk"
          variant="outlined"
          value={description}
          onChange={(e) => setDescription(e.target.value.toUpperCase())}
          InputLabelProps={{ shrink: true }}
          multiline
          inputProps={{ maxLength: 250 }}
          required
          rows={2}
          sx={{
            "& .MuiOutlinedInput-root": {
              alignItems: "flex-start",
            },
            "& textarea": {
              resize: "vertical",
              minHeight: "80px",
            },
          }}
        />
        <Typography variant="caption" color="textSecondary">
          Maksimal 250 karakter • {description.length}/250
        </Typography>
      </MDBox>
    </MDBox>
  );

  useEffect(() => {
    if (formSubmittedProduct) {
      handleAddProduk();
      setFormSubmittedProduct(false);
    }
  }, [formSubmittedProduct]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Produk
                </MDTypography>
              </MDBox>

              <MDBox
                mx={2}
                mt={3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="transparent"
                borderRadius="lg"
              >
                <MDButton variant="gradient" color="dark" onClick={() => setModalShow(true)}>
                  <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                  &nbsp;Tambah Produk
                </MDButton>
              </MDBox>
              <MDBox
                mx={2}
                mt={3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="transparent"
                borderRadius="lg"
              >
                <MDInput
                  fullWidth
                  label="Cari Produk..."
                  variant="outlined"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </MDBox>

              <MDBox pt={3} px={2}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  noEndBorder
                />
                {/* modal Edit Produk*/}
                {modalEdit}

                {/* modal Detail Produk */}
                {modalDetail}

                {/* modal Delete Produk */}
                {modalDelete}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* modal post */}
      <MyModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        title="Tambah Produk"
        body={renderForm}
        onSubmit={() => {
          if (formRef.current) {
            formRef.current.requestSubmit();
          }
        }}
        submitText="Simpan"
        colorButtonSubmit="info"
      />
    </DashboardLayout>
  );
}

export default Produk;
